export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.$i18n.onBeforeLanguageSwitch = async (oldLocale, newLocale, isInitialSetup, nuxtApp) => {
      // const authStore = useUserStore();
      
      // if (authStore.isUserLoggedIn) {
      //   authStore.updateUserSetting("selectedLang", newLocale);
      // }
    }
  })